import { render } from "./Home.vue?vue&type=template&id=7d6a532d&ts=true&lang=pug"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/olimago/Documents/www/escape-if-you-can-01/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__